module.exports = __webpack_public_path__ + "media/Loops 90 Drums.dbd7c45e.wav";